// tslint:disable: cyclomatic-complexity
import styled, { css } from 'styled-components';

import { media } from '../../../lib/StyledComponents/StyledComponents';
import { cssDeclaration } from '../Utils/Styles/cssDeclaration';
import { BaseInputStyles } from '../Form/TextInput/InputStyles';
import { normalizeColor } from '../Utils/Styles/normalizeColor';
import Box from '../Layout/Box';

// tslint:disable:max-line-length
const DatePickerStyles = css`
  .DayPicker {
    ${
      ({ theme: { themeTwo, themeTwo: { datePicker: { overlay } } } }) => css`
        /* width */ ${cssDeclaration(themeTwo, 'width', overlay && overlay.width ? overlay.width : '25rem')};
      `
    }
    font-size: 1rem;
  }

  .DayPicker-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    flex-direction: row;
    user-select: none;
  }

  /* CALENDAR CONTAINERS */
  .DayPicker-Months {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }

  .DayPicker-Month {
    display: table;
    table-layout: fixed;
    width: 100%;
    margin-top: 1em;
    border-collapse: separate;
    border-spacing: 0 1px;
    user-select: none;
  }

  /* PREV/NEXT ARROWS */
  .DayPicker-NavButton {
    position: absolute;
    display: inline-block;
    width: ${({ theme: { themeTwo: { datePicker: { input } } } }) => input.iconSize && input.iconSize.width ? input.iconSize.width : '2em'};
    height: ${({ theme: { themeTwo: { datePicker: { input } } } }) => input.iconSize && input.iconSize.height ? input.iconSize.height : '2em'};
    cursor: pointer;
    background-position: center;
    background-repeat: no-repeat;
    background-size: ${({ theme: { themeTwo: { datePicker: { navButton: { backgroundSize } } } }}) => backgroundSize};
  }

  .DayPicker-NavButton--next {
    top: 1em;
    right: 0;
    left: auto;

    ${({ theme: { themeTwo } }) => {
      const color = normalizeColor(themeTwo, themeTwo.datePicker.navButton.color);
      const nextIcon = themeTwo.datePicker.navButton.nextIcon;

      return `background-image: url(${nextIcon(color)});`;
    }}
  }

  .DayPicker-NavButton--prev {
    top: 1em;
    left: 0;
    right: auto;

    ${({ theme: { themeTwo } }) => {
      const color = normalizeColor(themeTwo, themeTwo.datePicker.navButton.color);
      const prevIcon = themeTwo.datePicker.navButton.prevIcon;

      return `background-image: url(${prevIcon(color)});`;
    }}
  }

  .DayPicker-NavButton--interactionDisabled {
    display: none;
  }

  /* CALENDAR LABEL I.E. MONTH NAME & YEAR */
  .DayPicker-Caption {
    display: table-caption;
  }

  .DayPicker-Caption > div {
    text-align: center;

    ${({theme: { themeTwo, themeTwo: { datePicker: { monthLabel } }} }) => monthLabel && css`
       /* font-size */ ${monthLabel.fontSize ? cssDeclaration(themeTwo, 'font-size', monthLabel.fontSize) : 'font-size: 2rem'};
      font-weight: ${monthLabel.fontWeight};
    `}
  }

  /* DAYS THE OF THE WEEK LABEL */
  .DayPicker-Weekdays {
    display: table-header-group;
  }

  .DayPicker-WeekdaysRow {
    display: table-row;
    padding: 0;
  }

  .DayPicker-Weekday {
    display: table-cell;
    padding: 0.5em;
    text-align: center;

    ${({theme: { themeTwo, themeTwo: { datePicker: { weekdayLabel } } }}) => css`
      font-weight: ${weekdayLabel.fontWeight};

       /* font-size */ ${weekdayLabel.fontSize ? cssDeclaration(themeTwo, 'font-size', weekdayLabel.fontSize) : 'font-size: 1rem'};
       /* border */ ${weekdayLabel.border && cssDeclaration(themeTwo, 'border', weekdayLabel.border)};
       /* padding */ ${weekdayLabel.padding && cssDeclaration(themeTwo, 'padding', weekdayLabel.padding)};
       /* color */ ${cssDeclaration(themeTwo, 'color', weekdayLabel.color)}

    `}
  }

  .DayPicker-Weekday abbr[title] {
    text-decoration: none;
    border: none;
  }

  .DayPicker-Body {
    display: table-row-group;
  }

  .DayPicker-Week {
    display: table-row;
  }

  /* DAY CELL */
  .DayPicker-Day {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
    cursor: pointer;

    ${({ theme: { themeTwo, themeTwo: { datePicker: { dayCell } } } }) => css`
       /* padding */ ${cssDeclaration(themeTwo, 'padding', (dayCell.padding ? dayCell.padding : '1x'))};
       /* font-size */ ${cssDeclaration(themeTwo, 'font-size', (dayCell.fontSize ? dayCell.fontSize : '2x'))};
       /* border */ ${dayCell.border && cssDeclaration(themeTwo, 'border', dayCell.border)};
    `}

    div { text-align: center; }
  }

  .DayPicker--interactionDisabled .DayPicker-Day {
    cursor: default;
  }

  .DayPicker-Footer {
    display: flex;
    justify-content: center;
    ${({ theme: { themeTwo } }) => css`
       /* margin */ ${themeTwo.datePicker.footer && cssDeclaration(themeTwo, 'margin', themeTwo.datePicker.footer.margin)};
    `}
  }

  .DayPicker-TodayButton {
    border: none;
    background-color: transparent;
    background-image: none;
    box-shadow: none;
    color: ${({ theme: { themeTwo, themeTwo: { global } }}) => normalizeColor(themeTwo, global.colors.link)};
    font-size: 1.6rem;
    cursor: pointer;
  }

  .DayPicker-Day--outside {
    color: ${({ theme }) => theme.colorSlate};
    cursor: default;
  }

  .DayPicker-Day--disabled {
    cursor: default;
    ${({ theme: { themeTwo, themeTwo: { datePicker: { dayCell: { disabled: { color }}}}}}) => cssDeclaration(themeTwo, 'color', color)};
  }

  .DayPicker-NavButton:focus,
  .DayPicker-Day:focus,
  .DayPicker-wrapper:focus,
  button:focus {
    ${({theme: { themeTwo }}) => {
      const { focusRing } = themeTwo.datePicker;

      return css`
        /* outline */ ${focusRing && focusRing.outline && cssDeclaration(themeTwo, 'outline', focusRing.outline)};
        /* box-shadow */ ${focusRing && focusRing.boxShadow && cssDeclaration(themeTwo, 'box-shadow', focusRing.boxShadow)};
     `;
    }}
  }

  .DayPicker-Day:focus {
    /* border-radius */ ${({ theme: { themeTwo } }) => cssDeclaration(themeTwo, 'border-radius', themeTwo.datePicker.dayCell.borderRadius)};
  }

  .DayPicker-Day--due {
    ${({ theme: { themeTwo } }) => {
      const { datePicker: { dayCell: { due, borderRadius } } } = themeTwo;

      return due && css`
        padding: 0;
        text-align: center;
        font-weight: ${due.fontWeight};
        /* color */ ${due && due.color && cssDeclaration(themeTwo, 'color', due.color)};
        /* background-color */ ${due && due.backgroundColor && cssDeclaration(themeTwo, 'background-color', due.backgroundColor)};
        /* border */ ${due.border && cssDeclaration(themeTwo, 'border', due.border)};
        /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', borderRadius)};

        .due-text {
          font-size: 1.6rem;
          /* color */ ${due.dueText && due.dueText.color && cssDeclaration(themeTwo, 'color', due.dueText.color)};
          /* font-size */ ${due.dueText && css`${cssDeclaration(themeTwo, 'font-size', due.dueText.fontSize)}`};
          /* line-height */ ${due.dueText && due.dueText.lineHeight && css`${cssDeclaration(themeTwo, 'line-height', due.dueText.lineHeight)}`};
        }
      `;
    }}
  }

  .DayPicker-Day--selected,
  .DayPicker-Day--selected.DayPicker-Day--due {
    position: relative;

    ${({ theme: { themeTwo, themeTwo: { datePicker: { dayCell: { borderRadius, selected, due } } } }}) => css`
      font-weight: ${selected.fontWeight};
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', selected.backgroundColor)}
      /* color */ ${cssDeclaration(themeTwo, 'color', selected.color)}
      /* border-radius */ ${cssDeclaration(themeTwo, 'border-radius', borderRadius)};

      /* style due text weight separately from selected styles */
      &.DayPicker-Day--selected.DayPicker-Day--due .due-text {
        /* font-weight */ ${due && due.dueText && due.dueText.fontWeight && cssDeclaration(themeTwo, 'font-weight', due.dueText.fontWeight)}
        /* color - to override dueText color for stateless due cell */ ${cssDeclaration(themeTwo, 'color', selected.color)}
      }
    `}
  }

  /* day cell hover styles */
  .DayPicker:not(.DayPicker--interactionDisabled) {
    .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
      font-weight: 700;

      ${({theme: { themeTwo }}) => {
        const { datePicker } = themeTwo;
        const { borderRadius, selected: { selectHover }, due } = themeTwo.datePicker.dayCell;
        const { hover } = themeTwo.datePicker.dayCell;
        const { topLeft, bottomLeft, topRight, bottomRight } = borderRadius;

        return css`
          /* background-color */ ${cssDeclaration(themeTwo, 'background-color', datePicker.dayCell.hover.backgroundColor)};
          /* color */  ${cssDeclaration(themeTwo, 'color', datePicker.dayCell.hover.color)};
          /* font-weight-on-hover */ ${hover && hover.fontWeight && cssDeclaration(themeTwo, 'font-weight', hover.fontWeight)};
          /* border-radius-on-hover */ ${cssDeclaration(themeTwo, 'border-radius', { topLeft, bottomLeft, topRight, bottomRight })};

          &.DayPicker-Day--due {
            /* background-color-on-hover */ ${due && due.hover && due.hover.backgroundColor && cssDeclaration(themeTwo, 'background-color', due.hover.backgroundColor)};
            /* color-on-hover */ ${due && due.hover && due.hover.color && cssDeclaration(themeTwo, 'color', due.hover.color)};
            /* font-weight-on-hover */ ${due && due.hover && due.hover.fontWeight && cssDeclaration(themeTwo, 'font-weight', due.hover.fontWeight)};

            .due-text {
              /* color-on-hover */ ${due && due.dueText && due.dueText.hover && due.dueText.hover.color && cssDeclaration(themeTwo, 'color', due.dueText.hover.color)};
            }
          }

          &.DayPicker-Day--selected {
            /* background-color-on-hover */ ${selectHover && cssDeclaration(themeTwo, 'background-color', selectHover.backgroundColor)};
            /* color-on-hover */ ${selectHover && cssDeclaration(themeTwo, 'color', selectHover.color)};
            /* font-weight-on-hover */ ${selectHover && selectHover.fontWeight && cssDeclaration(themeTwo, 'font-weight', selectHover.fontWeight)};

            .due-text {
              /* color-on-hover */ ${selectHover && cssDeclaration(themeTwo, 'color', selectHover.color)};
            }
          }
       `;
    }}
    }
  }

  /* DayPickerInput */
  .DayPickerInput {
    input {
      ${BaseInputStyles}
      padding-right: 2.75em;

      ${({ theme: { themeTwo } }) => {
        const color = normalizeColor(themeTwo, themeTwo.datePicker.input.iconColor.base);
        const disabledColor = themeTwo.datePicker.input.iconColor.disabled ? normalizeColor(themeTwo, themeTwo.datePicker.input.iconColor.disabled) : color;
        const icon = themeTwo.datePicker.input.icon;

        const iconOffset = themeTwo.global.edgeSize[themeTwo.form.input.padding.horizontal] || themeTwo.form.input.padding.horizontal;

        return css`
        background-image: url(${icon && icon(color)});
        background-position: right ${iconOffset} center;
        /* input-width */ ${themeTwo.datePicker.input.width && cssDeclaration(themeTwo, 'width', themeTwo.datePicker.input.width)};

          &:disabled {
            background-image: url(${icon && icon(disabledColor)});
          }
        `;
      }}

      background-repeat: no-repeat;
    }
  }

  .DayPickerInput-OverlayWrapper {
    position: relative;
  }

  .DayPickerInput-Overlay {
    display: flex;
    justify-content: center;
    position: absolute;
    margin-bottom: 1em;
    border-top: none;
    padding: 1em;

    // centers overlay on mobile
    left: 50%;
    transform: translateX(-50%);
    ${media.xsmall`
      left: 0;
      transform: translateX(0%);
    `}

    ${({ theme: { themeTwo }}) => {
      if (themeTwo.datePicker.overlay) {
        const { backgroundColor, boxShadow, border, borderRadius, padding } = themeTwo.datePicker.overlay;

        return css`
          z-index: ${themeTwo.global.zIndex.high};
          /* background-color */ ${backgroundColor && cssDeclaration(themeTwo, 'background-color', backgroundColor)};
          /* box-shadow */ ${boxShadow && cssDeclaration(themeTwo, 'box-shadow', boxShadow)};
          /* border */ ${border && cssDeclaration(themeTwo, 'border', border)};
          /* border-radius */ ${borderRadius && cssDeclaration(themeTwo, 'border-radius', borderRadius)};
          /* padding */ ${padding && cssDeclaration(themeTwo, 'padding', padding)};
        `;
      }
    }}
  }
`;

export const DatePickerContainer = styled(Box)`
  ${DatePickerStyles}
`;

export const DateRangePickerContainer = styled(DatePickerContainer)`
  .DayPicker-Day--selected {
    border-radius: 0;
  }

  ${({ theme: { themeTwo }}) => {
      const { borderRadius } = themeTwo.datePicker.dayCell;
      const { topLeft, bottomLeft, topRight, bottomRight } = borderRadius;

      return css`
        .DayPicker-Day--selected.DayPicker-Day--start {
          ${cssDeclaration(themeTwo, 'border-radius', { topLeft, bottomLeft })};
          font-weight: 700;
        }

        .DayPicker-Day--selected.DayPicker-Day--end {
          ${cssDeclaration(themeTwo, 'border-radius', { topRight, bottomRight })};
          font-weight: 700;
        }
      `;
    }}
  }
`;
